import { ApplicationSettingEnum } from '../enums';

export class ApplicationSettingResult {
    public id: number = 0;
    public key: ApplicationSettingEnum = ApplicationSettingEnum.Email;
    public value: string = '';

    /////////////////////Front-End////////////////////
    public valueIsNotValid: boolean;

    constructor() {
        this.valueIsNotValid = false;
    }
}
